import Vue from 'vue'

import RbStoreLocator from '@/elements/store-locator/store-locator.vue'
Vue.component('rb-store-locator', RbStoreLocator)

import RbCertifiedReseller from '@/elements/certified-reseller/certified-reseller.lazy.vue'
Vue.component('rb-certified-reseller', RbCertifiedReseller)
